/**
 * @generated SignedSource<<0e312fc93814d5799123ab67187d7f00>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type HubNoteQuery$variables = Record<PropertyKey, never>;
export type HubNoteQuery$data = {
  readonly me: {
    readonly hubNoteDismissed: boolean;
    readonly id: string;
  };
  readonly nextSurvey: {
    readonly displayTitle: string;
    readonly id: string;
    readonly linkUrl: string;
  } | null | undefined;
};
export type HubNoteQuery = {
  response: HubNoteQuery$data;
  variables: HubNoteQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "Me",
    "kind": "LinkedField",
    "name": "me",
    "plural": false,
    "selections": [
      (v0/*: any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "hubNoteDismissed",
        "storageKey": null
      }
    ],
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "Checkin",
    "kind": "LinkedField",
    "name": "nextSurvey",
    "plural": false,
    "selections": [
      (v0/*: any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "displayTitle",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "linkUrl",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "HubNoteQuery",
    "selections": (v1/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "HubNoteQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "02d9d67c9c329e253390308d0495f744",
    "id": null,
    "metadata": {},
    "name": "HubNoteQuery",
    "operationKind": "query",
    "text": "query HubNoteQuery {\n  me {\n    id\n    hubNoteDismissed\n  }\n  nextSurvey {\n    id\n    displayTitle\n    linkUrl\n  }\n}\n"
  }
};
})();

(node as any).hash = "5c2b28cb6b6e90d99b061c67a13cb601";

export default node;
